export default __webpack_public_path__ + "static/media/logo-open.a884bac3.svg";